import { render, staticRenderFns } from "./TeamTable.vue?vue&type=template&id=d39f52e0&scoped=true&"
import script from "./TeamTable.vue?vue&type=script&lang=js&"
export * from "./TeamTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39f52e0",
  null
  
)

export default component.exports